import {FormControl, FormField} from 'platform/components';

import {FieldPathByValue} from 'react-hook-form';

import {pushGtmEvent} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';

interface PageItemSwitchProps {
  index: number;
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  name: FieldPathByValue<DeliveryNoteDocumentPreviewFormDefinition, boolean>;
}

export function PageItemSwitch(props: PageItemSwitchProps) {
  return (
    <FormField
      isDisabled={!props.isConfirmed}
      control={props.control}
      type="switch"
      name={props.name}
      onChange={() => {
        pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_toggle_item_active'});
      }}
    />
  );
}
